<template>
  <div>
    <section class="p-box">
      <div class="p-box__body">
        <Loading v-show="loading" />
        <template v-if="competitors && !loading">
          <div class="info p-box__info">
            <div class="c-info">
              <div class="c-info__icon"><Icon name="iconQuestion" /></div>
              <div class="c-info__content">
                <p>{{ $t('pages.CompaniesLocationStore.competitor.info1') }}</p>
                <p>{{ $t('pages.CompaniesLocationStore.competitor.info2') }}</p>
              </div>
            </div>
          </div>
          <div v-if="competitors.data.length">
            <div class="p-stores">
              <div
                v-for="(competitor, i) in competitors.data"
                :key="i"
                class="p-stores__item"
              >
                <div class="c-grid content__wrapper">
                  <div class="item__wrapper c-grid__items">
                    <div class="c-grid__item c-grid__item__s__12 c-grid__item__m__4 c-grid__item__l__4">
                      <p class="p-stores__name">{{ competitor.attributes.name }}</p>
                    </div>
                    <div class="c-grid__item c-grid__item__s__12 c-grid__item__m__5 c-grid__item__l__5">
                      <p class="sites__label">{{ $t('labels.connectedSites') }}</p>
                      <ul v-if="competitor.attributes.sites.length" class="sites__group">
                        <li
                          v-for="( site, j ) in competitor.attributes.sites.filter(site => !!site.url)"
                          :key="j"
                          class="sites__item"
                        >
                          <span>
                            <KkSiteIcon :name="site.site_type" />
                          </span>
                        </li>
                      </ul>
                      <p v-else class="sites__warn">{{ $t('messages.noConnectedSites') }}</p>
                    </div>
                    <div class="actions__wrapper c-grid__item c-grid__item__s__12 c-grid__item__m__3 c-grid__item__l__3">
                      <router-link :to="{ name: 'CompaniesLocationStoreCompetitorEdit', params: { company_uuid: companyUuid, store_uuid: storeUuid, competitor_id: competitor.id }}" class="p-stores__action__item">
                        <img :src="iconPencilPath" alt="" class="p-stores__action__icon">
                        {{ $t('pages.CompaniesLocationStore.competitor.showDetail') }}
                      </router-link>
                      <div
                        v-if="isEditable"
                        class="deleteButton p-stores__action__item"
                        @click="submitDeleteCompetitor(competitor.id)"
                      >
                        <img :src="iconCrossPath" alt="" class="p-stores__action__icon">
                        {{ $t('labels.delete') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <p v-text="$t('pages.CompaniesLocationStore.competitor.noData')" />
          </div>
          <div class="c-button c-button--right">
            <div>
              {{ competitors.meta.competitor_count }} / {{ competitors.meta.max_competitor_count }} {{ $t('labels.registeredStoresCount') }}
            </div>
            <div v-if="canAddCompetitor">
              <router-link
                :to="{ name: 'CompaniesLocationStoreCompetitorNew', params: { company_uuid: companyUuid, store_uuid: storeUuid }}"
                class="c-button__item c-button__item--primary"
              >
                <img :src="iconPlusPath" alt="" class="c-button__icon">
                {{ $t('pages.CompaniesLocationStore.competitor.addCompetitor') }}
              </router-link>
            </div>
          </div>
        </template>
      </div>
    </section>
  </div>
</template>

<script>
import Loading from '../Loading.vue'
import { KkSiteIcon } from '../base'
import iconPlusPath from '../../../../images/common/icon_plus.svg'
import iconPencilPath from '../../../../images/common/icon_pencil.svg'
import iconCrossPath from '../../../../images/common/icon_cross.svg'
import Icon from '../Icon'

export default {
  name: 'Competitors',
  components: {
    Loading,
    KkSiteIcon,
    Icon,
  },
  props: {
    competitors: {
      type: Object,
      required: true
    },
    canAddCompetitor: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    isEditable: {
      type: Boolean,
      required: true
    },
  },
  emits: ['delete'],
  data () {
    return {
      companyUuid: this.$route.params.company_uuid,
      storeUuid: this.$route.params.store_uuid,
      iconPlusPath,
      iconPencilPath,
      iconCrossPath,
    }
  },
  methods: {
    submitDeleteCompetitor(competitor_id) {
      if (confirm(this.$t('pages.CompaniesLocationStore.competitor.confirmToDelete'))) {
        this.$emit('delete', competitor_id)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.deleteButton {
  cursor: pointer;
}

.content {
  &__wrapper {
    width: 100%;
  }
}

.item {
  &__wrapper {
    align-items: center;
  }
}

.sites {
  &__group {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -4px -12px;
  }
  &__label {
    font-weight: bold;
    margin-bottom: 4px;
  }
  &__warn {
    font-weight: bold;
    margin-top: 12px;
    color: #E9446A;
  }
  &__item {
    padding: 0 2px 10px;
    span {
      display: flex;
      align-items: center;
      width: 38px;
      height: 38px;
      padding: 4px;
      border: 1px solid rgba(228, 231, 235, .5);
      border-radius: 8px;
      background-color: #FFF;
    }
    img {
      display: block;
    }
  }
}

.actions {
  &__wrapper {
    display: grid;
    justify-content: flex-end;
    align-items: center;
    padding-top: 0;
    border-top: 0;
  }
}

.info {
  margin-top: 16px;
}
</style>
